import { useCallback, useState } from "react";
const useLegalCheckbox = () => {
    const [isLegalChecked, setIsLegalChecked] = useState(false);
    const [showErrorFlash, setErrorFlash] = useState(false);
    const handleCheckbox = useCallback((isLegalChecked) => {
        setIsLegalChecked(isLegalChecked);
    }, []);
    const handleErrorFlash = () => {
        setErrorFlash(true);
        setTimeout(() => {
            setErrorFlash(false);
        }, 500);
    };
    return {
        isLegalChecked,
        showErrorFlash,
        handleCheckbox,
        handleErrorFlash,
    };
};
export default useLegalCheckbox;
